module.exports = __webpack_public_path__ + "static/media/square.48721764.png";